import DeleteIcon from '@mui/icons-material/Delete';
import { removeLocale } from '../../../actions.js';
import iconButtonCellFactory from './icon-button-cell.jsx';

export default iconButtonCellFactory({
  getButtonProps() {
    return {
      children: <DeleteIcon />
    };
  },
  getAction(props) {
    return removeLocale({ locale: props.row.code });
  }
});
